// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Zvdy","left":"InfoRow_left__1C286"};